import React from 'react';

interface ISubtitleProps {
  children: React.ReactNode;
}

export const Subtitle: React.FC<ISubtitleProps> = ({ children }) => (
  <span className="tw-lf-body-regular-sm tw-grid-area-[subtitle]">
    {children}
  </span>
);
